import React from "react";
import "./index.css";

const IconButton = React.forwardRef(function IconButton({ testid, icon, height, width, onClick, text, className = '', visible = true, ...params }, ref) {
  return (
    <button
      ref={ref}
      data-testid={testid}
      {...params}
      className={`button-container ${className}`}
      style={{ height, width, display: visible ? '' : 'none' }}
      onClick={onClick}
    >
      <div className={`button-content ${params.disabled ? 'disabled' : ''}`}>
        <span className="icon-button-icon" style={{ height, width }}>{icon}</span>
        {text && <span className="icon-button-text">{text}</span>}
      </div>
    </button>
  );
});

export default IconButton;
